import shallowCompare from '../../helpers/shallowCompare';

export const optionsListSelector = (state) => state.options || [];

export const optionsStateSelector = (optionsSettings) => (state) =>
  optionsListSelector(state).find(
    (optionState) =>
      !optionState.error && shallowCompare(optionsSettings, optionState.fetchOptions),
  );

export const optionsErrorSelector = (optionsSettings) => (state) =>
  optionsListSelector(state).some(
    (optionState) => optionState.error && shallowCompare(optionsSettings, optionState.fetchOptions),
  );
